import { render, staticRenderFns } from "./ItemRefSet.vue?vue&type=template&id=44ad07a6&scoped=true&"
import script from "./ItemRefSet.vue?vue&type=script&lang=js&"
export * from "./ItemRefSet.vue?vue&type=script&lang=js&"
import style0 from "./ItemRefSet.vue?vue&type=style&index=0&id=44ad07a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ad07a6",
  null
  
)

export default component.exports